export var ServerEvent;
(function (ServerEvent) {
    ServerEvent["NewTx"] = "new-tx";
    ServerEvent["PeriodStats"] = "period-stats";
    ServerEvent["Blockhash"] = "blockhash";
})(ServerEvent || (ServerEvent = {}));
export var ClientEvent;
(function (ClientEvent) {
    ClientEvent["NewTxSubscribe"] = "subscribe:new-tx";
    ClientEvent["NewTxUnsubscribe"] = "unsubscribe:new-tx";
    ClientEvent["NewTxByMakerSubscribe"] = "subscribe:new-tx-by-maker";
    ClientEvent["NewTxByMakerUnsubscribe"] = "unsubscribe:new-tx-by-maker";
    ClientEvent["PeriodStatsSubscribe"] = "subscribe:period-stats";
    ClientEvent["PeriodStatsUnsubscribe"] = "unsubscribe:period-stats";
    ClientEvent["BlockhashSubscribe"] = "subscribe:blockhash";
    ClientEvent["BlockhashUnsubscribe"] = "unsubscribe:blockhash";
})(ClientEvent || (ClientEvent = {}));
export var Room;
(function (Room) {
    Room["NewTx"] = "new-tx";
    Room["NewTxByMaker"] = "new-tx-by-maker";
    Room["PeriodStats"] = "period-stats";
    Room["Blockhash"] = "blockhash";
})(Room || (Room = {}));
//# sourceMappingURL=index.js.map